import { toSnakeCase } from '../utils';
import type { ProductEventOverrides } from './types';

export const POKER_EVENT_OVERRIDES: ProductEventOverrides = {
    'Game Selected': {
        override: (builtProps, e: { gameProvider?: string }) => {
            return {
                ...builtProps,
                'Game Provider': toSnakeCase(e.gameProvider || ''),
                'Third Party Lobby': ['playtech_poker'].includes(toSnakeCase(e.gameProvider || '')) ? 'true' : 'false'
            };
        }
    }
};
